import { gatewayPageBuilder } from "../../../../gateways/gatewayPageBuilder";

export const getMyDrafts = async (): Promise<any> => {
    const token = sessionStorage.getItem("token");
    if (!token) throw new Error("No auth token found");

    const { data } = await gatewayPageBuilder.get<any>(
        "page-builder/drafts/self",
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );

    return data.data;
};
